function socialMediaPreviewDialog () {
  return {
    restrict: 'E',
    templateUrl: '/arts/dialogs/social-media-preview/social-media-preview.html?$$REVISION$$'
  }
}

export { socialMediaPreviewDialog }
